import { render, staticRenderFns } from "./ServiceFeeManagement.vue?vue&type=template&id=969c5526&scoped=true"
import script from "./ServiceFeeManagement.vue?vue&type=script&lang=js"
export * from "./ServiceFeeManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceFeeManagement.vue?vue&type=style&index=0&id=969c5526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969c5526",
  null
  
)

export default component.exports